import { render, staticRenderFns } from "./FamiliesCollection.vue?vue&type=template&id=390d4fac&"
import script from "./FamiliesCollection.vue?vue&type=script&lang=js&"
export * from "./FamiliesCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports